import { api } from "@/api/client";

export const SCOPES = ["tokens.read", "prices.read", "prices.stream"] as const;
export type Scope = typeof SCOPES[number];

export interface ApiKey {
  id: string;
  project_id: string;
  name: string;
  prefix: string;
  // Raw secret, decrypted server-side from encrypted_secret. Always present
  // on freshly-created keys; null only on legacy rows that pre-date the
  // encryption migration.
  secret: string | null;
  origin_allowlist: string[] | null;
  scopes: Scope[] | null;
  last_used_at: string | null;
  revoked_at: string | null;
  created_at: string;
}

// Same shape as ApiKey now — kept as a named alias for create-site clarity
// (secret is guaranteed non-null on the create response).
export type ApiKeyCreated = ApiKey & { secret: string };

export const keysApi = {
  list: (pid: string) => api.get<ApiKey[]>(`/projects/${pid}/keys`),
  create: (pid: string, name: string, opts: { origin_allowlist?: string[]; scopes?: Scope[] } = {}) =>
    api.post<ApiKeyCreated>(`/projects/${pid}/keys`, {
      name,
      origin_allowlist: opts.origin_allowlist ?? null,
      scopes: opts.scopes ?? null,
    }),
  update: (pid: string, kid: string, patch: { name?: string; origin_allowlist?: string[] | null; scopes?: Scope[] | null }) =>
    api.patch<ApiKey>(`/projects/${pid}/keys/${kid}`, patch),
  revoke: (pid: string, kid: string) => api.delete<{ ok: true }>(`/projects/${pid}/keys/${kid}`),
};
